import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=6df0af2a"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports